import React from 'react';
import classNames from 'classnames';
import { Icon, LoadingSpinner } from 'Permafrost/index';
import { StyledTooLarge, StyledGenerateReport } from './GenerateReport.styles';
export const GenerateReport = (props) => {
    const { actionHandler, className, disabled, downloadReady, id, isPolling, tooLarge } = props;
    if (tooLarge) {
        return (React.createElement(StyledTooLarge, { className: className, "data-cy": props['data-cy'], id: id },
            React.createElement("p", { className: "too-large-message" }, "There is too much data to generate a report. Please use our client libraries."),
            React.createElement("a", { href: "https://docs.indico.io", target: "_blank", rel: "noreferrer", className: "docs-link" },
                React.createElement("span", { className: "LinkList-Text" }, "How to Generate a Large Report"))));
    }
    else {
        return (React.createElement(StyledGenerateReport, { "aria-label": "Generate and Download Report", className: classNames('generate-button', className, downloadReady ? 'download normal' : 'generate cta'), "data-cy": props['data-cy'], disabled: disabled || isPolling, id: id, onClick: () => actionHandler() }, downloadReady ? (React.createElement(React.Fragment, null,
            React.createElement(Icon, { name: "fa-file-download", size: [14] }),
            " Download Report")) : isPolling ? (React.createElement(React.Fragment, null,
            React.createElement(LoadingSpinner, null),
            " Generating...")) : (React.createElement(React.Fragment, null,
            React.createElement(Icon, { name: "plus", size: [14] }),
            " Generate Report"))));
    }
};
//# sourceMappingURL=GenerateReport.js.map